import DataTableChannel from "./data_table_channel";

export default class PaymentHistoryChannel extends DataTableChannel {
  static identifier = "PaymentHistoryChannel";
}
